import ThemedSelect from "../shared/ThemedSelect.jsx";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { createClientContact } from "../../services/apiClient.js";

// Guided Client-Contact entry on the Progress screen (legacy ProgressPage
// tblClientContact — Karen 2026-07-25, job 76393). Recording the first client
// call or the go-ahead advice stamps the milestone date on the claim (which
// clears the RDR "First Contact" / "Go Ahead Contact Not Completed" rules) and
// drops a plain progress entry "Initial Contact: …" / "Go Ahead Contact: …".
// Each type is offered only while its date is unstamped; the box self-hides once
// both are recorded. Result presets mirror 1.0 (and services/progress.js).
const RESULTS = {
  initial: [
    "Called - made appointment",
    "Called - no reply no answer machine",
    "Called - no reply left message on answer machine",
    "Emailed - sent email requesting appointment",
  ],
  go_ahead: [
    "Called - advised of go ahead",
    "Called - no reply no answer machine",
    "Called - no reply left message on answer machine",
    "Emailed - advising of go ahead",
  ],
};
const TYPE_LABEL = { initial: "Initial Contact", go_ahead: "Go Ahead Contact" };

export default function ClaimClientContact({ claimId, clientContact, onCreated }) {
  const cc = clientContact || {};
  const types = [];
  if (!cc.first_contact_date) types.push("initial");
  if (!cc.initial_go_ahead_date) types.push("go_ahead");

  const [type, setType] = useState("");
  const [result, setResult] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (types.length === 0) return null; // both milestones recorded → nothing to do

  const activeType = types.includes(type) ? type : types[0];

  async function create() {
    if (!result) return;
    setBusy(true);
    setError("");
    try {
      await createClientContact(claimId, activeType, result);
      setResult("");
      if (onCreated) onCreated();
    } catch (err) {
      setError(err.response?.data?.error || "Unable to create the entry.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mb-3 border rounded p-2">
      <div className="fw-semibold small text-uppercase text-muted mb-1" style={{ letterSpacing: "0.06em" }}>
        Client Contact
      </div>
      <div className="small text-muted mb-2">
        When contacting the client for the first time, or advising them of a Go-Ahead job, create the progress entry from the list.
      </div>
      <div className="d-flex align-items-center gap-2 flex-wrap">
        {types.length > 1 ? (
          <ThemedSelect
            size="sm"
            style={{ width: 190 }}
            value={activeType}
            onChange={(e) => {
              setType(e.target.value);
              setResult("");
            }}
          >
            {types.map((t) => (
              <option key={t} value={t}>{TYPE_LABEL[t]}</option>
            ))}
          </ThemedSelect>
        ) : (
          <span className="badge bg-body-tertiary text-body border">{TYPE_LABEL[activeType]}</span>
        )}
        <ThemedSelect size="sm" style={{ width: 340 }} value={result} onChange={(e) => setResult(e.target.value)}>
          <option value="">Select result…</option>
          {RESULTS[activeType].map((r) => (
            <option key={r} value={r}>{r}</option>
          ))}
        </ThemedSelect>
        <Button size="sm" disabled={!result || busy} onClick={create}>Create Entry</Button>
      </div>
      {error ? <div className="text-danger small mt-1">{error}</div> : null}
    </div>
  );
}
